import React, { type ComponentType } from 'react';
import { CampaignAnatomy } from './components/deck/CampaignAnatomy';
import { ControlTower } from './components/deck/ControlTower';
import { ControlTowerValue } from './components/deck/ControlTowerValue';
import { Cover } from './components/deck/Cover';
import { DeliveryModel } from './components/deck/DeliveryModel';
import { DermxShowcase } from './components/deck/DermxShowcase';
import { LeoLandscape } from './components/deck/LeoLandscape';
import { OperatingModel } from './components/deck/OperatingModel';
import { ProvenWork } from './components/deck/ProvenWork';
import { RocheLearning } from './components/deck/RocheLearning';
import { StoryboardSlide } from './components/deck/StoryboardSlide';
import { ValueProposition } from './components/deck/ValueProposition';
import { WhyWeExist } from './components/deck/WhyWeExist';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_m3ewpi',
  title: 'Snakker for LEO Pharma',
  component: Cover
}, {
  id: 'scr_why001',
  title: 'Snakker — why we exist',
  component: WhyWeExist
}, {
  id: 'scr_roc002',
  title: 'What we learned from Roche',
  component: RocheLearning
}, {
  id: 'scr_prf007',
  title: 'Already delivering campaign work with LEO Pharma',
  component: ProvenWork
}, {
  id: 'scr_lnd011',
  title: 'Brands, campaigns and markets already in play',
  component: LeoLandscape
}, {
  id: 'scr_ana008',
  title: 'Inside a LEO campaign flow',
  component: CampaignAnatomy
}, {
  id: 'scr_del003',
  title: 'Snak campaign delivery model and cost structure',
  component: DeliveryModel
}, {
  id: 'scr_val004',
  title: 'Value proposition for LEO Pharma',
  component: ValueProposition
}, {
  id: 'scr_ctl005',
  title: 'Control Tower — the enterprise platform',
  component: ControlTower
}, {
  id: 'scr_ctv009',
  title: 'What Control Tower brings to LEO',
  component: ControlTowerValue
}, {
  id: 'scr_ope006',
  title: 'The LEO operating model',
  component: OperatingModel
}, {
  id: 'scr_stb012',
  title: 'The full deck, page by page',
  component: StoryboardSlide
}];